import { CurrentSort } from '@e3dc-react/shell/Elements/Table'
import { ChargingCardModel } from '../../Libs/e-mobility/charging-cards'
import { ChargingSessionsFilters } from '../../Libs/e-mobility/charging-sessions'
import { TariffTableData } from '../../Libs/e-mobility/tariffs'

import { EMobilityActionType, EMobilityAction } from './EMobilityStateModel'

export const updateChargingCardsSort = (sort: CurrentSort<ChargingCardModel> | undefined): EMobilityAction => ({
  type: EMobilityActionType.SetChargingCardsSort,
  payload: sort,
})

export const updateChargingSessionsFilters = (filters: ChargingSessionsFilters | undefined): EMobilityAction => ({
  type: EMobilityActionType.SetChargingSessionsFilters,
  payload: filters,
})

export const updateTariffsSort = (sort: CurrentSort<TariffTableData> | undefined): EMobilityAction => ({
  type: EMobilityActionType.SetTariffsSort,
  payload: sort,
})

export const updateTourRunning = (isRunning: boolean): EMobilityAction => ({
  type: EMobilityActionType.SetTourRunning,
  payload: isRunning,
})

export const updateTourCompleted = (isCompleted: boolean): EMobilityAction => ({
  type: EMobilityActionType.SetTourCompleted,
  payload: isCompleted,
})

export const updateChargingCardsMobileSort = (sort: CurrentSort<ChargingCardModel>): EMobilityAction => ({
  type: EMobilityActionType.SetChargingCardsMobileSort,
  payload: sort,
})

export const updateTariffsMobileSort = (sort: CurrentSort<TariffTableData>): EMobilityAction => ({
  type: EMobilityActionType.SetTariffsMobileSort,
  payload: sort,
})
